import React, { Fragment, ReactNode, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIcon from "../../../images/contact-modal/close.svg";
interface ModalProps extends React.HTMLProps<HTMLDivElement> {
  open: boolean;
  closeModal: () => void;
  children: ReactNode;
}

export default function Modal({ open, closeModal, children }: ModalProps) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        initialFocus={cancelButtonRef}
        onClose={closeModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="relative flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0 mx-auto">
            <Transition.Child
              as={Fragment}
              enter="transition-[translate_opacity] duration-200 ease-in delay-300"
              enterFrom="transform translate-y-[100%] opacity-0"
              enterTo="transform translate-y-0 opacity-100"
              leave="transition-[translate_opacity] duration-300 ease-out delay-0"
              leaveFrom="transform translate-y-0 opacity-100"
              leaveTo="transform translate-y-[100%] opacity-0"
            >
              <Dialog.Panel className="relative transform bg-emerald-50 p-8 md:p-14 text-left shadow-xl transition-all mt-20 mb-8 sm:w-full sm:max-w-2xl grow mx-2 md:mx-auto">
                <button
                  type="button"
                  className="absolute right-0 -top-16 md:-right-16 border p-2 border-emerald-50 bg-transparent"
                  onClick={closeModal}
                >
                  <img src={CloseIcon} alt="Close icon" />
                </button>
                <div>
                  <div className="mt-3">{children}</div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
